import React, { useState } from 'react'
import Image from "../../elements/Image";
import Whitelogo from "../../../assets/image/footer-logo.png";
import Input from "../../form/Input";
import Icon1 from "../../../assets/images/bitcoin.png";
import Icon2 from "../../../assets/images/ethereum.png";
import Icon3 from "../../../assets/images/litecoin.png";
import Icon4 from "../../../assets/images/ripple.png";
import FlexibleSelect from "../../form/select/FlexibleSelect";
import Button from "../../form/Button";

const WhoWeAre = ({ data }) => {
  const [payWithCoin, setPayWithCoin] = useState(1); 
  const [buyCoin, setBuyCoin] = useState(3);
  const [feesIncluded, setfeesIncluded] = useState(3);

  return (
    <>
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
        <div className="relative flex items-start gap-60">
          <div className="relative w-2/5 z-10">
            <div className="relative z-10 bg-primary bg-opacity-10 border border-primaryBorder rounded-3xl py-10 px-9 backdrop-blur-lg">
              <div className="w-28 mx-auto overflow-hidden">
                <Image src={Whitelogo} alt="" effect="" classes="object-cover" />
              </div>

              <div className="relative items-center border border-gray-200 rounded-lg bg-[#091F0D] mt-12">
                <div className="relative flex items-center border-b border-gray-200 p-4 gap-3">
                  <div className="relative z-[9999] overflow-visible">
                    <FlexibleSelect
                      selectedValue={payWithCoin}
                      onChange={(val) => setPayWithCoin(val)}
                      dropdownData={[
                        { _id: 1, image: Icon1, name: "BTC", value: 1 },
                        { _id: 2, image: Icon2, name: "ETH", value: 2 },
                        { _id: 3, image: Icon3, name: "LTC", value: 3 },
                        { _id: 4, image: Icon4, name: "XRP", value: 4 },
                      ]}
                      dropdownButtonClass={"!bg-transparent !text-white"}
                      iconClasses={"text-white"}
                    />
                  </div>

                  <div className="relative flex-1">
                    <Input
                      inputType="number"
                      label={"Pay with Dollars"}
                      labelClasses={"!text-[#E5E7EB] !text-base text-right"}
                      inputClasses={"!bg-transparent !text-2xl !border-none rounded-lg !text-right !h-8 !py-2 !pr-0 text-white"}
                      inputPlaceholder={"100"}
                    />
                  </div>
                </div>

                <div className="relative flex items-center rounded-lg p-4 gap-3">
                  <div className="relative overflow-visible">
                    <FlexibleSelect
                      selectedValue={buyCoin}
                      onChange={(val) => setBuyCoin(val)}
                      dropdownData={[
                        { _id: 1, image: Icon1, name: "BTC", value: 1 },
                        { _id: 2, image: Icon2, name: "ETH", value: 2 },
                        { _id: 3, image: Icon3, name: "LTC", value: 3 },
                        { _id: 4, image: Icon4, name: "XRP", value: 4 },
                      ]}
                      dropdownButtonClass={"!bg-transparent !text-white"}
                      iconClasses={"text-white"}
                    />
                  </div>

                  <div className="relative flex-1">
                    <Input
                      inputType="number"
                      label={"Buy Bitcoin"}
                      labelClasses={"!text-[#E5E7EB] !text-base text-right"}
                      inputClasses={"!bg-transparent !text-2xl !border-none rounded-lg !text-right !h-8 !py-2 !pr-0"}
                      inputPlaceholder={"0.00056"}
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-between gap-6 mt-4">
                <div className="w-40">
                  <FlexibleSelect
                    selectedValue={feesIncluded}
                    onChange={(val) => setfeesIncluded(val)}
                    dropdownData={[
                      { _id: 1, name: "Fees Included", value: 1 },
                      { _id: 2, name: "Fees Included Saw", value: 1 },
                    ]}
                    dropdownButtonClass={"!bg-transparent !text-white !border-none"}
                    iconClasses={"text-white"}
                  />
                </div>

                <div className="font-Poppins text-sm text-[#E5E7EB]"><h4>5 BTC≈569,487.40004 USD</h4></div>
              </div>

              <Button
                buttonLabel={"Continue"}
                buttonClasses={"w-full !bg-[#00A754] mt-10"}
              />

            </div>

            <div className="absolute top-0 left-0 h-full w-full flex justify-between z-0">
              <div className="absolute top-10 -left-20 border-[35px] rounded-full border-[#043C29] max-w-full w-[288px] h-[288px]"></div>
              <div className="absolute -bottom-16 -right-28 border-[35px] rounded-full border-[#043C29] max-w-full w-[389px] h-[389px]"></div>
            </div>
          </div>

          <div className="relative w-3/5 z-10">
            <h4 className="text-xl font-semibold mb-2 text-primary uppercase">
              {data.SubTitle}
            </h4>
            <h2 className="text-5xl text-white font-semibold mb-3">{data.title}</h2>
            <div className="text-xl leading-relaxed text-secondary">
              <p dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>
          </div>

          {/* Radial BG */}
          <div className="absolute inset-0 -translate-x-40 m-auto w-[800px] h-[800px] rounded-full bg-radial-custom z-0"></div>
        </div>
      </div>
    </>
  );
};

export default WhoWeAre;
